import {NgForOf} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';

import {SfDetailsItem} from '../../models/salesforce-orgs.interface';

@Component({
  standalone: true,
  selector: 'q9ma-connection-details-list',
  templateUrl: './connection-details-list.component.html',
  imports: [MatIconModule, NgForOf, TranslateModule],
  styleUrls: ['./connection-details-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConnectionDetailsListComponent {
  @Input() items: SfDetailsItem[] = [];
}
